import { make } from 'vuex-pathify';
import { LoanPriorityService } from '../services/loan-priority.service.js';
import Logger from '@/lib/logger.js';

const service = new LoanPriorityService();

const normalizeRangeList = (range = []) => {
  if (!Array.isArray(range)) return [];

  return range.map((item) => ({ ...item }));
};

const getDefaultRangeValues = (type) => {
  if (type == 'TotalScores' || type == 'totalScores') {
    return { priorityLevels: 0 };
  }

  return {
    unsecured: 0,
    motorVehicle: 0,
    realEstate: 0,
    cashSecured: 0,
    chattel: 0
  };
};

const normalizeGeneratedRangeList = (range = [], config = {}) => {
  const numberOfRecords = Number(config.numberOfRecords);
  const startingValue = Number(config.startingValue);
  const interval = Number(config.interval);

  if (
    !Number.isFinite(numberOfRecords) ||
    !Number.isFinite(startingValue) ||
    !Number.isFinite(interval)
  ) {
    return normalizeRangeList(range);
  }

  let previousMax = startingValue;

  return Array.from({ length: numberOfRecords }, (_, index) => {
    const from = index === 0 ? startingValue : previousMax + 1;
    const to = startingValue + interval * (index + 1);

    previousMax = to;

    return {
      ...getDefaultRangeValues(config.type),
      ...(range[index] || {}),
      from,
      to
    };
  });
};

const commitRange = (commit, type, range) => {
  if (type == 'PastDueDays') {
    commit('SET_PAST_DUE_DAYS_RANGE', range);
  } else if (type == 'LoanAmount') {
    commit('SET_LOAN_AMOUNT_RANGE', range);
  } else if (type == 'TotalScores' || type == 'totalScores') {
    commit('SET_TOTAL_SCORES_RANGE', range);
  }
};

const state = {
  pastDueDaysRange: [],
  loanAmountRange: [],
  totalScoresRange: []
};

const mutations = make.mutations(state);

const actions = {
  async fetchLoanPrioritySettings({ commit }, payload) {
    try {
      const { data } = await service.fetchLoanPrioritySettings(
        payload.type,
        payload?.page,
        payload?.itemsPerPage || payload?.limit
      );
      const range = normalizeRangeList(data.data);
      
      commitRange(commit, payload.type, range);

      return {
        ...data,
        data: range
      };
    } catch (error) {
      Logger.error('Fetching Loan Priority Settings');
      throw error;
    }
  },

  async generateRange({ commit }, payload) {
    const response = await service.generateRange(payload);
    const responseData = response.data || {};
    const range = normalizeGeneratedRangeList(responseData.data, payload);

    commitRange(commit, payload.type, range);

    return {
      ...responseData,
      data: range
    };
  },

  async updateLoanPrioritySetting({ commit }, { type, updates }) {
    try {
      const normalizedUpdates = normalizeRangeList(updates);
      const { data } = await service.updateLoanPrioritySetting(type, normalizedUpdates);
      const range = normalizeRangeList(data.data);
      
      commitRange(commit, type, range);

      return {
        ...data,
        data: range
      };
    } catch (error) {
      Logger.error('Updating Loan Priority Settings');
      throw error;
    }
  }
};

export default {
  state,
  mutations,
  actions
};
